module.exports = __webpack_public_path__ + "img/li.ef46ce0e.png";